/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { CosmosRichText, CosmosText, EdsIcon } from "@components/elements";
import { CosmosInterviewFragment } from "@cosmos/hygraph-schema";
import { css } from "@panda/css";
import { HStack, VStack } from "@panda/jsx";
import React from "react";

export const Interview = ({ interviewee, questions = [] }: CosmosInterviewFragment): React.JSX.Element | null => {
	if (!questions || !questions?.length) return null;

	return (
		<VStack alignItems="start" gap="eds.dimension.40">
			{questions?.map((question, i) => {
				if (!question.question) return null;
				return (
					<HStack alignItems="start" gap="eds.dimension.24" key={`${question.question}-${i}`}>
						<EdsIcon icon="QuestionCircleFilled" gradient="blue" size="lg" />
						<VStack alignItems="start" gap="eds.dimension.24">
							<CosmosRichText variant="headingLG" color="eds.text.primary" html={question?.question} />
							<div>
								{interviewee ? (
									<CosmosText className={css({ display: "inline" })} variant="paragraphMD">
										<strong>{interviewee}:</strong>&nbsp;
									</CosmosText>
								) : null}
								<CosmosRichText variant="paragraphMD" color="eds.text.secondary" html={question?.answer} />
							</div>
						</VStack>
					</HStack>
				);
			})}
		</VStack>
	);
};
